import { render, staticRenderFns } from "./AllowancesPlanDetailsEdit.vue?vue&type=template&id=41ccf85c&scoped=true&"
import script from "./AllowancesPlanDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ccf85c",
  null
  
)

export default component.exports